(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nestful-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nestful-bundle')) {
  class NestfulBundle extends HTMLElement {
    static price(price, quantity, rate) {
      const original = price * quantity;
      const saving = Math.round(original * rate / 100);
      return { original, saving, total: original - saving };
    }
    static rate(quantity, rates) {
      return rates.reduce((best, [minimum, rate]) => quantity >= minimum ? Math.max(best, rate) : best, 0);
    }
    static valid(quantity, price) {
      return Number.isSafeInteger(quantity) && quantity >= 1 && Number.isSafeInteger(price * quantity * 100);
    }
    static limit(config) {
      let max = config.maximum == null ? Infinity : Math.max(0, config.maximum - config.variantCartQuantity);
      if (config.inventoryManaged && config.inventoryPolicy === 'deny') max = Math.min(max, Math.max(0, config.inventory - config.variantCartQuantity));
      return max;
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
      this.selected = 1;
      this.custom = 4;
      this.expanded = false;
      this.waiting = false;
      this.failed = false;
      this.events = new AbortController();
      this.form = document.getElementById(this.dataset.form);
      this.info = this.closest('product-info');
      this.input = this.querySelector('[data-custom]');
      this.quantity = this.querySelector('[data-submit-quantity]');
      if (!this.form || !this.info) return;
      this.quantity.type = 'hidden';
      this.querySelector('[data-fallback]').hidden = true;
      this.querySelector('[data-controls]').hidden = false;
      this.listen(this, 'click', (event) => {
        const choice = event.target.closest('[data-q]');
        const step = event.target.closest('[data-delta]');
        if (choice && !choice.disabled) this.choose(Number(choice.dataset.q));
        if (step && !step.disabled) {
          const next = this.custom + Number(step.dataset.delta);
          if (next >= 4 && this.allowed(next)) { this.custom = next; this.input.value = String(next); this.render(); }
        }
      });
      this.listen(this, 'keydown', (event) => {
        if (!event.target.matches('[data-q]') || !['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const options = [...this.querySelectorAll('[data-q]')].filter(button => !button.disabled);
        const current = options.indexOf(event.target);
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : (current + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1) + options.length) % options.length;
        const target = options[index];
        if (target) { this.choose(Number(target.dataset.q), true); target.focus(); }
      });
      this.listen(this.input, 'input', () => {
        const quantity = Number(this.input.value);
        if (this.input.value.trim() !== '' && quantity >= 4 && NestfulBundle.valid(quantity, this.config.price)) this.custom = quantity;
        this.render();
      });
      this.listen(this.form, 'submit', (event) => {
        if (this.blocked()) {
          event.preventDefault(); event.stopImmediatePropagation();
          if (this.invalid()) { this.expanded = true; this.render(); this.input.focus(); }
        } else this.quantity.value = String(this.value());
      }, true);
      this.listen(this.form, 'change', (event) => {
        if (event.target.name === 'id' && !event.target.value) { this.waiting = false; this.config.available = false; this.render(); }
      });
      this.unsubscribers = [];
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
          if (this.info.contains(event.data?.event?.target) || this.info.contains(event.data?.target)) { this.waiting = true; this.render(); }
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (data.sectionId !== this.dataset.section) return;
          this.request?.abort();
          if (this.update(data.html)) { this.waiting = false; this.failed = false; this.render(); }
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh()));
      }
      this.listen(window, 'pageshow', (event) => { if (event.persisted) this.refresh(); });
      this.render();
    }
    listen(target, name, fn, capture = false) {
      target.addEventListener(name, fn, {signal: this.events.signal, capture});
    }
    disconnectedCallback() {
      this.events?.abort(); this.request?.abort(); this.unsubscribers?.forEach(stop => stop()); this.ready = false;
    }
    text(key, values = {}) {
      return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('[' + name + ']', String(value)), this.config.texts[key]);
    }
    money(value) {
      return new Intl.NumberFormat(this.config.locale, {style:'currency', currency:this.config.currency}).format(value / 100);
    }
    value() { return this.selected === 4 ? this.custom : this.selected; }
    invalid() { return this.selected === 4 && (this.input.value.trim() === '' || Number(this.input.value) < 4 || !NestfulBundle.valid(Number(this.input.value), this.config.price)); }
    allowed(quantity) {
      const min = this.config.minimum || 1, step = this.config.increment || 1;
      return this.config.available && NestfulBundle.valid(quantity, this.config.price) && quantity >= min && (quantity - min) % step === 0 && quantity <= NestfulBundle.limit(this.config);
    }
    blocked() { return this.dataset.preview === 'true' || this.waiting || this.failed || this.invalid() || !this.allowed(this.value()); }
    choose(quantity, keyboard = false) {
      if (quantity === 4) {
        if (this.selected === 4 && this.invalid()) { this.input.focus(); return; }
        this.expanded = keyboard || this.selected !== 4 || !this.expanded;
      } else { this.expanded = false; this.input.value = String(this.custom); }
      this.selected = quantity;
      this.render();
    }
    update(html) {
      const node = [...html.querySelectorAll('nestful-bundle')].find(element => element.dataset.section === this.dataset.section);
      if (!node) return false;
      this.config = JSON.parse(node.querySelector('[data-bundle-config]').textContent);
      return true;
    }
    async refresh() {
      this.request?.abort();
      const controller = new AbortController(); this.request = controller;
      this.waiting = true; this.render();
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('variant', this.form.querySelector('[name="id"]').value);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, {signal:controller.signal, cache:'no-store'});
        if (!response.ok) throw new Error('Section unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (controller.signal.aborted) return;
        if (!this.update(html)) throw new Error('Bundle unavailable');
        this.failed = false;
      } catch (error) { if (error.name !== 'AbortError') this.failed = true; }
      finally { if (this.request === controller && !controller.signal.aborted) { this.waiting = false; this.render(); } }
    }
    render() {
      const invalid = this.invalid(), quantity = this.value();
      const rate = NestfulBundle.rate(quantity, this.config.rates);
      const amount = NestfulBundle.price(this.config.price, quantity, rate);
      const unavailable = !this.allowed(quantity);
      this.querySelectorAll('[data-q]').forEach(button => {
        const q = Number(button.dataset.q), selected = q === this.selected;
        button.setAttribute('aria-checked', String(selected)); button.tabIndex = selected ? 0 : -1;
        button.disabled = q === 4 ? !this.config.available || NestfulBundle.limit(this.config) < 4 : !this.allowed(q);
        if (q < 4) {
          const d = NestfulBundle.rate(q, this.config.rates);
          button.querySelector('.discount').textContent = d ? this.text('save',{percent:d}) : this.text('single');
          button.querySelector('.amount').textContent = this.money(NestfulBundle.price(this.config.price,q,d).total);
        }
      });
      const open = this.selected === 4 && this.expanded;
      const head = this.querySelector('.morehead');
      head.setAttribute('aria-expanded', String(open));
      this.querySelector('.more').classList.toggle('selected',this.selected === 4);
      this.querySelector('.morebody').hidden = !open;
      this.querySelector('.morebenefit').textContent = this.selected === 4 && !open && !invalid ? this.text('selected',{quantity,percent:rate}) : this.text('upTo',{percent:Math.max(...this.config.rates.map(t=>t[1]))});
      this.input.setAttribute('aria-invalid',String(invalid || unavailable));
      this.querySelector('[data-delta="-1"]').disabled = invalid || this.custom <= 4 || !this.allowed(this.custom - 1);
      this.querySelector('[data-delta="1"]').disabled = invalid || !this.allowed(this.custom + 1);
      this.querySelectorAll('[data-tier]').forEach(tier => tier.classList.toggle('active', !invalid && !unavailable && (quantity >= 10 ? 10 : quantity >= 5 ? 5 : 4) === Number(tier.dataset.tier)));
      const summary = this.querySelector('.summary');
      summary.hidden = quantity === 1 || invalid || unavailable || this.failed;
      summary.dataset.compact = String(quantity < 4);
      this.querySelector('.count').hidden = quantity < 4;
      this.querySelector('.total').hidden = quantity < 4;
      this.querySelector('.total').textContent = this.money(amount.total);
      this.querySelector('.saving').textContent = this.text('saving',{unit:this.money(amount.total/quantity),saving:this.money(amount.saving)}) + (this.config.texts.tax ? ' · '+this.config.texts.tax : '');
      const error = this.querySelector('.error');
      error.textContent = invalid ? this.text('invalid') : this.failed ? this.text('retry') : this.waiting ? '' : unavailable ? this.text('unavailable') : '';
      error.hidden = !error.textContent;
      this.quantity.value = invalid ? '' : String(quantity);
      const blocked = this.blocked(); this.dataset.blocked = String(blocked);
      const button = this.form.querySelector('[type="submit"]');
      if (button) {
        if (blocked && !button.disabled) {button.dataset.nfBundleBlocked='true';button.disabled=true;}
        else if (!blocked && button.dataset.nfBundleBlocked) {button.disabled=false;delete button.dataset.nfBundleBlocked;}
      }
    }
  }
  customElements.define('nestful-bundle', NestfulBundle);
}
  } catch(e) { console.error(e); }
})();

})();
